import { render } from "./RegistrasiSuratMasuk.vue?vue&type=template&id=62aa3807&scoped=true"
import script from "./RegistrasiSuratMasuk.vue?vue&type=script&lang=js"
export * from "./RegistrasiSuratMasuk.vue?vue&type=script&lang=js"

import "./RegistrasiSuratMasuk.vue?vue&type=style&index=0&id=62aa3807&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aa3807"]])

export default __exports__